import TableDateCell from '../../../../shared/components/table-cells/TableDateCell/TableDateCell';
import { Alignments } from '../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../shared/components/ui/Table/models/table-column.model';
import { castTo } from '../../../../shared/utils/cast-to';
import { stringToPascalCase } from '../../../../shared/utils/string-to-pascal-case/string-to-pascal-case.util';
import { ReleaseModel } from '../../../models/release.model';
import PlatformsTableCell from '../../PlatformsTableCell/PlatformsTableCell';

export const releasesTableColumnsDef: TableColumnDef[] = [
  {
    field: 'versionName',
    headerName: 'version',
    sortable: true,
    alignment: Alignments.LEFT,
    width: '378px',
  },
  {
    field: 'platform',
    headerName: 'Platform',
    alignment: Alignments.LEFT,
    width: '97px',
    sortable: false,
    valueGetter: row => {
      const currentRow = castTo<ReleaseModel>(row);

      if (currentRow.formattedPlatforms) {
        return PlatformsTableCell(currentRow.formattedPlatforms);
      }

      return '';
    },
  },
  {
    field: 'updateDate',
    headerName: 'Last updated',
    alignment: Alignments.LEFT,
    width: '123px',
    sortable: true,
    valueGetter: row => {
      return (
        <TableDateCell
          date={castTo<ReleaseModel>(row).updateDate}
        ></TableDateCell>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    alignment: Alignments.RIGHT,
    width: '65px',
    sortable: false,
    valueGetter: row =>
      row.status ? stringToPascalCase(castTo<string>(row.status)) : '',
  },
];
